package com.devi3east.bashbuddy.dashboard.responses

import com.devi3east.bashbuddy.auth.domain.models.UserType
import com.devi3east.bashbuddy.cart.responses.TicketPurchaseResponse
import com.devi3east.bashbuddy.features.events.common.data.models.Event
import com.devi3east.bashbuddy.features.events.common.data.models.Ticket
import com.devi3east.bashbuddy.prizeList.domain.models.Prize
import kotlinx.serialization.Serializable

@Serializable
data class DashboardResponse(
    val userType: UserType,
    val events: List<Event> = emptyList(),
    val tickets: List<Ticket> = emptyList(),
    val purchases: List<TicketPurchaseResponse> = emptyList(),
    val prizes: List<Prize> = emptyList()
)